<template>
  <d-navbar
    toggleable="md"
    type="dark"
    class="main-navbar-top">
    <d-collapse
      is-nav
      id="nav-collapse">
      <d-navbar-nav class="flex-fill">
        <d-nav-item
          class="main-navbar-top-item">
          <d-button
            class="main-navbar-top-item-button text-nowrap"
            theme="success"
            @click.prevent="$router.push('/zamowienia/nowy')">
            <i class="material-icons">add</i>
            Dodaj zamówienie
          </d-button>
          <d-button
            class="main-navbar-top-item-button ml-2"
            theme="primary"
            @click.prevent="openModal">
            <i class="material-icons mr-1">euro</i>
            Przyjmij płatność
          </d-button>
          <d-button
            class="main-navbar-top-item-button ml-2"
            theme="danger"
            @click.prevent="$router.push('/wyloguj')">
            <i class="material-icons">power_settings_new</i>
            Wyloguj się
          </d-button>
        </d-nav-item>
      </d-navbar-nav>
    </d-collapse>
    <settlements-payment
      :key="key_payment_module"
      :close-modal="closeModal"
      :show-modal="show_payment_module"/>
  </d-navbar>
</template>

<script>
import SettlementsPayment from '../../views/Settlements/SettlementsPayment';

export default {
  name: 'main-navbar',
  components: {
    SettlementsPayment
  },
  data () {
    return {
      show_payment_module: false,
      key_payment_module: 0,
    };
  },
  methods: {
    openModal () {
      this.show_payment_module = true;
    },
    closeModal () {
      this.show_payment_module = false;
      this.key_payment_module += 1;
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/scss/layout/main-navbar.scss';
</style>
